<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <div v-if="show">
            <GamePopupOne :data-set="dataSet" @close="close" @load-more-game="loadMoreGame" @go-to-deposit="goToDeposit"
                @open-register-popup="openRegisterPopup" @go-to-profile="goToProfile" @go-to-play-game="GoToPlayGame"
                @open="open" @select-group="selectGroup" />
        </div>
    </div>

    <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <GamePopupTwo :data-set="dataSet" @close="close" @load-more-game="loadMoreGame" @go-to-deposit="goToDeposit"
            @open-register-popup="openRegisterPopup" @go-to-profile="goToProfile" @go-to-play-game="GoToPlayGame"
            @open="open" @select-group="selectGroup" />

    </div>

    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, defineExpose, computed, inject, defineEmits } from 'vue'
import { useRouter } from 'vue-router'
import { groupGames } from '@/api/game'
import { playClickSound } from "@/utils/media";
import StatusPopup from '@/components/common/statusPopup.vue'
import { useGameStore } from '@/stores/games'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useUserStore } from '@/stores/user'
import GamePopupOne from '@/themes/themeOne/game/gamePopup.vue';
import GamePopupTwo from '@/themes/themeTwo/game/gamePopup.vue';
import { GameData, GameItem, PAGE_SIZE } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const router = useRouter()
const gameStore = useGameStore()
const userStore = useUserStore()
const themeStore = useThemeStore()

const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const pageNumber = ref(1)

const show = ref(false)
const gameCount = ref(0)
const loadedGameCount = ref(0)
const showLoadMore = ref(true)
const showPopover = ref(false);
const groupList = computed(() =>
    gameStore.groupList.map((item: any) => ({
        id: item.id,
        icon: item.customIcon,
        name: item.name // Ensure 'text' property for PopoverAction
    }))
)
const activeItem = ref(groupList.value[0] ? groupList.value[0].id : 0)
const gameList = ref<GameItem[]>([])
const favoriteGameList = computed(() => gameStore.groupList[1].games)
const loading = ref(false)
const groupID = ref()
const balance = computed(() => userStore.balance)
const mainHeader = ref<{ url: string; display: boolean }>({ url: '', display: true })
const depositButon = ref({
    colorCode: '',
    display: false,
    redirectUrl: ''
})
const profileButtonData = ref({
    url: '',
    display: false,
    redirectUrl: ''
})

const dataSet = computed<GameData>(() => ({
    show: show.value,
    showLoadMore: showLoadMore.value,
    showPopover: showPopover.value,
    groupList: groupList.value,
    activeItem: activeItem.value,
    gameList: gameList.value,
    loading: loading.value,
    balance: balance.value,
    mainHeader: mainHeader.value,
    depositButon: depositButon.value,
    profileButtonData: profileButtonData.value,
    gameCount: gameCount.value
}))

const emits = defineEmits(['resetSelectedGroup', 'goToProfile'])
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')

const open = (id: number | string) => {
    const URL = localStorage.getItem('componetList')

    if (URL) {
        try {
            const componentList = JSON.parse(URL)
            const headerComponent = componentList.find(
                (item: any) => item.component_name === 'header'
            )
            mainHeader.value = headerComponent.appIcon
            depositButon.value = headerComponent.depositButton
            profileButtonData.value = headerComponent.profileButton
        } catch (error) {
            console.error("Failed to parse componetList from localStorage", error)
        }
    }
    loadingRef.value.open()
    show.value = true
    groupID.value = id
    activeItem.value = id
    if (id == 'fav') {
        gameList.value = favoriteGameList.value
        gameCount.value = gameList.value.length
        showLoadMore.value = false
        loadingRef.value.close()
    } else {
        getGameGroupList()
    }

}

const close = () => {
    show.value = false
    gameList.value = []
    pageNumber.value = 1
    gameStore.getGameGroupListData()
    loadedGameCount.value = 0;
    emits('resetSelectedGroup')
}
const goToProfile = () => {
    emits('goToProfile')
}
const selectGroup = (item: any) => {
    loadingRef.value.open()
    groupID.value = item.id
    gameList.value = [];
    activeItem.value = item.id
    pageNumber.value = 1
    loadedGameCount.value = 0
    if (item.id == 'fav') {
        gameList.value = favoriteGameList.value
        gameCount.value = gameList.value.length
        loadingRef.value.close()
    } else {
        getGameGroupList()
    }
    showPopover.value = false
}
const loadMoreGame = () => {
    loading.value = true
    pageNumber.value++
    if (loadedGameCount.value < gameCount.value) {
        getGameGroupList()
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getGameGroupList = () => {
    let params = {
        pageNum: pageNumber.value,
        pageSize: PAGE_SIZE,
        groupId: groupID.value
    }
    groupGames(params).then(res => {
        loadingRef.value.close()
        let resData = res.data
        gameCount.value = resData.total
        loadedGameCount.value = loadedGameCount.value + PAGE_SIZE
        loading.value = false
        gameList.value = [...gameList.value, ...resData.rows];
        if (gameCount.value <= loadedGameCount.value) {
            showLoadMore.value = false
        } else {
            showLoadMore.value = true
        }
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const openRegisterPopup = (type: number) => {
    openRegisterLoginPopup?.(type)
}
const goToDeposit = () => {
    playClickSound()
    router.push(depositButon.value.redirectUrl)
}
const GoToPlayGame = (data: any) => {
    let token = localStorage.getItem('token')
    if (token) {
        router.push({ path: '/pgame', query: { game_type: data.id, game_maker: data.makerId } })
    } else {
        openRegisterPopup(1)
    }
}


defineExpose({
    open,
    selectGroup,
})


</script>